import React from 'react';
import clsx from 'clsx';

import './index.scss';
import ErrorText from 'components/atoms/Text/ErrorText';

const PcErrorArea = ({ message, position = 'absolute', message2row = false }) => {

  return (
    <div className={clsx(
      'PcErrorArea',
      { noError: !message },
      { error: !!message },
      { absolute: position === 'absolute' },
      { relative: position === 'relative' },
      { message2row }
    )}
    >
      <div className="M-EA-message">
        <ErrorText label={message} />
      </div>
    </div>
  );
};

export default PcErrorArea;